import React from "react";
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { BasquiatPaddingProps, useUnitPropsConverter } from "./units";
import Gap from "./Gap";

type HStackAlignment = "top" | "center" | "bottom" | "stretch";
type HStackFit = "fill" | "center" | "none" | "flex";

export type HStackProps = {
    alignment?: HStackAlignment;
    fit?: HStackFit;
    gap?: number | string;
    style?: StyleProp<ViewStyle>;
    children: React.ReactNode;
} & BasquiatPaddingProps;

const ALIGNMENT_MAP: { [key: string]: StyleProp<ViewStyle> } = {
    top: { alignItems: "flex-start" },
    center: { alignItems: "center" },
    bottom: { alignItems: "flex-end" },
    stretch: { alignItems: "stretch" },
};

const FIT_MAP: { [key: string]: StyleProp<ViewStyle> } = {
    center: { alignContent: "center", justifyContent: "center" },
    fill: { justifyContent: "space-between" },
    none: {},
    flex: {},
};

const CHILD_FIT_MAP: { [key: string]: StyleProp<ViewStyle> } = {
    center: {},
    fill: { flex: 1 },
    none: {},
    flex: { flex: 1 },
};

const styles = StyleSheet.create({
    hStack: {
        flexDirection: "row",
    },
});

export const HStack = ({
    gap,
    alignment = "center",
    fit = "none",
    style,
    children,
    ...paddingProps // BasquiatPaddingProps
}: HStackProps) => {
    const childrenCount = React.Children.count(children);
    const propsConverter = useUnitPropsConverter();
    const paddingStyle = propsConverter(paddingProps);
    return (
        <View style={[styles.hStack, paddingStyle, ALIGNMENT_MAP[alignment], FIT_MAP[fit], style]}>
            {gap && gap !== 0 && childrenCount > 1
                ? React.Children.map(children, (child, index) => (
                      <>
                          <View style={CHILD_FIT_MAP[fit]}>{child}</View>
                          {index < childrenCount - 1 ? <Gap gap={gap} mode="horizontal" /> : null}
                      </>
                  ))
                : children}
        </View>
    );
};

export default HStack;
